import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row-reverse pb-10 pt-10"
}
const _hoisted_2 = {
  class: "btn btn-secondary mb-1 col-2",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_3 = { class: "svg-icon fill-svg me-1" }
const _hoisted_4 = { class: "ps-1 me-1 ms-1 mt-0 mb-0 col-10 control-search-box-table-input d-flex" }
const _hoisted_5 = { class: "control-search-box-table-filter" }
const _hoisted_6 = { class: "icon is-small is-left" }
const _hoisted_7 = {
  class: "menu menu-sub menu-sub-dropdown w-30 col-6 menuCustomStyle mb-5",
  "data-kt-menu": "true",
  style: {"position":"fixed !important"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Filter By:")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_10 = { class: "px-7 container" }
const _hoisted_11 = {
  key: 0,
  class: "row"
}
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "filter-combined" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Review Type:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "all"
}, "All", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "standard"
}, "Standard", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "expedited"
}, "Expedited", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "exempted"
}, "Exempted", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "filter-combined" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "App Status:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "all2"
}, "All", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "submitted"
}, "Submitted", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "Re-assigned"
}, "Re-assigned", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "pending-approval"
}, "Pending of Approval", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "underreview"
}, "Needs Faculty Review", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "faculty-approved-not-submitted"
}, "Faculty Approved but not Submitted", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "mb-10 filter-combined" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Research Title:", -1)
const _hoisted_39 = { class: "mb-10 filter-combined" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "PI Email:", -1)
const _hoisted_41 = { class: "d-flex justify-content-end mb-5 mt-0 pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!

  return (!_ctx.filtersDisabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, {
              class: "fill-svg",
              src: "media/icons/duotune/general/gen031.svg"
            })
          ]),
          _createTextVNode(" Filter ")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            style: {"min-height":"94% !important"},
            class: "mt-0 mb-0",
            modelValue: _ctx.data.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.title) = $event)),
            placeholder: "Enter the title of the research",
            onKeyup: _ctx.applyFilter,
            name: "title"
          }, null, 8, ["modelValue", "onKeyup"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("i", {
                class: "fas fa-search",
                style: {"cursor":"pointer"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args)))
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (!_ctx.hideRadio)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "all",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.typeOfReview) = $event)),
                            value: "all"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.typeOfReview]
                          ]),
                          _hoisted_15,
                          _hoisted_16,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "standard",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.typeOfReview) = $event)),
                            value: "Standard"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.typeOfReview]
                          ]),
                          _hoisted_17,
                          _hoisted_18,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "expedited",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.typeOfReview) = $event)),
                            value: "Expedited"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.typeOfReview]
                          ]),
                          _hoisted_19,
                          _hoisted_20,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "exempted",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.typeOfReview) = $event)),
                            value: "Exempted"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.typeOfReview]
                          ]),
                          _hoisted_21,
                          _hoisted_22
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "all",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.appStatus) = $event)),
                            value: ""
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appStatus]
                          ]),
                          _hoisted_25,
                          _hoisted_26,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "submitted",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.appStatus) = $event)),
                            value: "Submitted"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appStatus]
                          ]),
                          _hoisted_27,
                          _hoisted_28,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "Re-assigned",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.appStatus) = $event)),
                            value: "Re-assigned"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appStatus]
                          ]),
                          _hoisted_29,
                          _hoisted_30,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "UnderReview",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.appStatus) = $event)),
                            value: "pending-approval"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appStatus]
                          ]),
                          _hoisted_31,
                          _hoisted_32,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "faculty-review",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data.appStatus) = $event)),
                            value: "faculty-review"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appStatus]
                          ]),
                          _hoisted_33,
                          _hoisted_34,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "faculty-approved-not-submitted",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.appStatus) = $event)),
                            value: "faculty-approved-not-submitted"
                          }, null, 512), [
                            [_vModelRadio, _ctx.data.appStatus]
                          ]),
                          _hoisted_35,
                          _hoisted_36
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode(_component_el_input, {
                modelValue: _ctx.data.title,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.title) = $event)),
                placeholder: "Enter Title",
                name: "title"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode(_component_el_input, {
                modelValue: _ctx.data.piEmail,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.piEmail) = $event)),
                placeholder: "Enter PI Email",
                name: "piEmail"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              type: "reset",
              class: "btn btn-sm btn-secondary btn-active-light-primary me-2",
              "data-kt-menu-dismiss": "true",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resetFilter()))
            }, " Reset "),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-sm btn-primary",
              "data-kt-menu-dismiss": "true",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.applyFilter()))
            }, " Apply ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}